import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { organizationsApi } from "../api";
import { showToast } from "../../../../utils/showToast";

export const SET_LOADING = "saga/admin/organizations/SET_LOADING";
export const SET_ACTIONS_LOADING = "saga/admin/organizations/SET_ACTIONS_LOADING";

export const ADD_ORGANIZATION = "saga/admin/organizations/ADD_ORGANIZATION";

export const TOGGLE_2FA = "saga/admin/organizations/TOGGLE_2FA";
export const TOGGLE_2FA_SUCCESS = "saga/admin/organizations/TOGGLE_2FA_SUCCESS";

export const EDIT_ORGANIZATION = "saga/admin/organizations/EDIT_ORGANIZATION";
export const EDIT_ORGANIZATION_SUCCESS = "saga/admin/organizations/EDIT_ORGANIZATION_SUCCESS";

export const DELETE_ORGANIZATION = "saga/admin/organizations/DELETE_ORGANIZATION";
export const DELETE_ORGANIZATION_SUCCESS = "saga/admin/organizations/DELETE_ORGANIZATION_SUCCESS";

export const FETCH_SETTINGS = "saga/admin/organizations/FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "saga/admin/organizations/FETCH_SETTINGS_SUCCESS";

export const FETCH_ORGANIZATIONS = "saga/admin/organizations/FETCH_ORGANIZATIONS";
export const FETCH_ORGANIZATIONS_SUCCESS = "saga/admin/organizations/FETCH_ORGANIZATIONS_SUCCESS";

export const RESET_STATUS = "saga/admin/organizations/RESET_STATUS";
export const SET_ERROR = "saga/admin/organizations/SET_ERROR";
export const SET_STATUS = "saga/admin/organizations/SET_STATUS";

const actionCreators = {
  fetchSettings: createAction(FETCH_SETTINGS),
  createOrg: createAction(ADD_ORGANIZATION),
  changeOrganization: createAction(EDIT_ORGANIZATION),
  toggleGlobal2fa: createAction(TOGGLE_2FA),
  deleteOrganization: createAction(DELETE_ORGANIZATION),
  resetStatus: createAction(RESET_STATUS)
};

export const {
  fetchSettings,
  createOrg,
  changeOrganization,
  toggleGlobal2fa,
  deleteOrganization,
  resetStatus
} = actionCreators;

export default function* watchOrganization() {
  yield takeLatestSafe(FETCH_SETTINGS, getSettings);
  yield takeLatestSafe(ADD_ORGANIZATION, addOrganization);
  yield takeLatestSafe(DELETE_ORGANIZATION, removeOrganization);
  yield takeLatestSafe(EDIT_ORGANIZATION, editOrganization);
  yield takeLatestSafe(TOGGLE_2FA, change2fa);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getSettings() {
  const settings = yield call(organizationsApi.getSettings);

  const orgs = yield call(organizationsApi.getOrganizations);

  yield put({
    type: FETCH_ORGANIZATIONS_SUCCESS,
    payload: orgs.data
  });

  yield put({
    type: FETCH_SETTINGS_SUCCESS,
    payload: settings.data
  });

  yield put({
    type: SET_LOADING,
    payload: false
  });
}

const getFilterParams = (fields) => {
  let formattedDataForRequest = {};

  fields.forEach(([key, data]) => {
    if (Array.isArray(data)) {
      if (key === "locational_overview_report_metrics" || key === "default_revenue_type_ids") {
        formattedDataForRequest[key] = data.map((item) => item.id.toString());
      } else {
        formattedDataForRequest[key] = data.map((item) => item.name);
      }
    } else if (typeof data == "object") {
      formattedDataForRequest[key] = data.id;
    } else {
      formattedDataForRequest[key] = data;
    }
  });

  return formattedDataForRequest;
};

function* addOrganization({ payload }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let fields = Object.entries(payload);

  yield call(organizationsApi.addOrganization, {
    organization: getFilterParams(fields)
  });

  yield put({ type: SET_STATUS, payload: "success" });
}

function* editOrganization({ payload: { id, data, dirtyFields } }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let fields = Object.keys(dirtyFields);

  let formattedDataForRequest = {};

  fields.forEach((key) => {
    formattedDataForRequest[key] = data[key];
  });

  let res = yield call(organizationsApi.updateOrganization, id, {
    organization: getFilterParams(Object.entries(formattedDataForRequest))
  });

  yield put({
    type: EDIT_ORGANIZATION_SUCCESS,
    payload: { id, data: res.data, haveNamesChanged: !!data.business_name }
  });
}

function* change2fa({ payload }) {
  try {
    let res = yield call(organizationsApi.toggleGlobal2fa, {
      params: { enable_global_2fa: !payload }
    });

    yield put({
      type: TOGGLE_2FA_SUCCESS,
      payload: !payload
    });

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}

function* removeOrganization(data) {
  try {
    let res = yield call(organizationsApi.removeOrganization, data.payload.id.toString());

    yield put({
      type: DELETE_ORGANIZATION_SUCCESS,
      payload: { id: data.payload.id }
    });

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}
